import isNewestOnBottom from './isNewestOnBottom';
import { isFeatureEnabled } from 'owa-feature-flags';

// TODO also add a condition for toggle-switch on reading pane WI - 92469
export default function shouldShowUnstackedReadingPane(): boolean {
    return isFeatureEnabled('mon-rp-unstackedConversation') && !isNewestOnBottom();
}
